import React, { useState, useEffect } from "react";
import SectionCard from "../../stories/components/SectionCard";
import { Tabs, Form, Icon, Col, Row } from "antd";
import MultistopOrder from "../../stories/components/MultistopOrder";
import AddressLocationsView from "../../stories/components/AddressLocationsView";
import { alertMessage, isEmpty } from "../../common/Common";
import DispalyOrderAccessorial from "../../stories/components/DisplayOrderAccessorial";
import Documents from "../../stories/components/Documents";
import AssignedDriverView from "../../stories/components/PickupDriverView";
import EditIcon from "../../../assets/images/EditIcon.svg";
import I18n from "../../common/I18n";
import { renderNotification } from "./OrderTypeIcons";
import { deleteSingleStop } from "../../api/OrdersApi";
import { renderAlertMessage } from "../../helpers/common";

const { Item: FormItem } = Form;

const MultiStopLocationsView = (props) => {
const { actionType, locationsInfo = [], accessorialDefs, orderTypeConfig, 
    config, getFieldDecorator, currentOrder, currentOrg, levelOfServices = [],
  refreshDetails, selectedWarehouse, isShipper = false, showActions = true, currentPreplan, setIsModified, 
  setOutofPreplan, orgSettings, orderDetails = {},accountComponentAccessorial,
  displayComponents,drivers,isCreditLimitExceed, updateAppointmentDetails, updateLocationDetails = () => {}, updateDeliverByDetails, updatePickupByDetails, updateOnHandDetails, updateReceivedDetails, updateActualDetails, orgRules = {}
} = props;

  const [showForm, setShowForm] = useState(false);
  const [activeKey, setActiveKey] = useState("1");
  const [locations, setLocations] = useState([...locationsInfo]);
  const isReadOnly = actionType === "view";
  const emptyText = "Not Available";
  const [commonLos, setCommonLos] = useState(null);
  const addStop = () => {

    if (config?.allow_single_stop_multiple_stop == "true") {
      const checkStop = locations[0]?.type_of_loc == "DELIVERY"
      if (checkStop) {
        renderNotification("Please make sure your first location is a pickup stop", "error");
        return
      }
    }
    setLocations([
        ...locations,
        {
            type_of_loc: "PICKUP",
            label_code: 'R',
            loc_order_sequence: locations.length,
        }
    ])
    setActiveKey((locations.length+1).toString())
  }

  const DeleteStop = (location_id) => {
    const location = locations.find((loc) => loc.id === location_id);

    const details = _.get(currentOrder, "customer_order_details", false);
    const payload = {
      location_id: location?.id || "",
      order_id: details.id,
      organization_id: currentOrg?.id || "",
      warehouse_id: details.warehouse_id,
      action_type: "DELETE_STOP"
    }

    const findIndex = currentOrder?.locations?.findIndex((location) => location.id === location_id);

    deleteSingleStop(payload).then((result) => {
      if (result.success) {
        alertMessage("Stop deleted successfully");
        setActiveKey(findIndex.toString());
        refreshDetails();
      } else {
        renderAlertMessage(result.errors);
      }
    })
      .catch((error) => {
        renderAlertMessage(error.message);
        console.error("Error deleting stop: ", error);
      }).finally(() => {
        // setIsLoading(false);
      });
  }


  useEffect(() => {
    setLocations([...locationsInfo])
  }, [locationsInfo])

  const updateLoscode = async (event, field, header, verify) => {
    if (commonLos?.Updateloscode) {
      await commonLos?.Updateloscode(event, field, header, verify);
    }
  };

  const levelOfServicesField = () => {
    const los = locations?.[0]?.los_name || locations?.[0]?.los_code || emptyText;
    return <div className="address-location-section">
      <Col className="address-location-details-los">
        <Row type="flex" gutter={16} className="address-location-los">
          <Col style={{ textAlign: 'left', padding: '5px' }}>
            <span className="details-heading">{I18n.t('general.level_of_service')}</span>:
            <span className="details-data location-code" style={{ paddingLeft: '5px' }}>
              {los}
            </span>
          </Col>
          {showActions && locations[0]?.id && (
            <Col span={4} className="edit-los-icon text-right" >
              <img
                src={EditIcon}
                alt=""
                onClick={(event) => updateLoscode(
                  event, 
                  'levelOfService', 
                  I18n.t('general.level_of_service'), 
                  true
                )}
              />
            </Col>
          )}
        </Row>
      </Col>
    </div>
  }

  const hasNewLocation = locations.some(loc => isEmpty(loc.location_id))
  return (
    <SectionCard
      title="Stops"
      extraActionNode={orgSettings?.individual_stop_los_order_level == "true" ? null : levelOfServicesField()}
    >
      <Tabs activeKey={activeKey} onChange={(key) => setActiveKey(key)}>
        {locations.map((loc, index) => {
          const stopKey = (index + 1).toString();
          return (
            <Tabs.TabPane
              tab={<span className="MSbutton-2-large">Stop {index + 1}</span>}
              key={stopKey}
            >
              <AddressLocationsView
                location={{...loc}} 
                locObj={loc}
                currentOrder={currentOrder} 
                orderTypeConfig={orderTypeConfig} 
                selectedWarehouse={selectedWarehouse ? selectedWarehouse : ""}
                currentOrg={currentOrg}
                levelOfServices={levelOfServices}
                refreshDetails={refreshDetails}
                accountId={orderDetails.account_id}
                config={config}
                showActions={showActions}
                isShipper={isShipper}
                currentPreplan={currentPreplan}
                setOutofPreplan={setOutofPreplan}
                setIsModified={setIsModified}
                orgSettings={orgSettings}
                updateAppointmentDetails={updateAppointmentDetails}
                updateDeliverByDetails={updateDeliverByDetails}
                updatePickupByDetails={updatePickupByDetails}
                updateOnHandDetails={updateOnHandDetails}
                updateReceivedDetails={updateReceivedDetails}
                commonLos={setCommonLos}
                updateLocationDetails={updateLocationDetails}
                DeleteStop={DeleteStop}
                orgRules={orgRules}
            />
            <DispalyOrderAccessorial
              accountComponentAccessorial={accountComponentAccessorial}
              config={config}
              displayComponents={displayComponents}
              title={""}
              //accRef={accessorialRef}
              drivers={drivers}
              updateOrderAccessorials={() => {}}
              processingRecords={loc?.accessorials || []}
             // prevAuthorizedInfo={authorizeDetails}
              actionType={"view"}
              currentOrg={currentOrg}
              currentOrder={currentOrder}
              accountId={currentOrder?.account?.id}
              haveMultipleLocations={currentOrder?.locations?.length > 1 || false}
              location={loc}
              showActions={showActions}
              isShipper={isShipper}
              setOutofPreplan={setOutofPreplan}
              setIsModified={setIsModified}
              refreshDetails={refreshDetails}
            />
            <Documents
                  getFieldDecorator={getFieldDecorator}
                  currentOrg={currentOrg}
                  accountId={orderDetails.account_id}
                  currentOrder={currentOrder}
                  typeOfOrder = {currentOrder.type_of_order}
                  documents={loc?.documents || []}
                  locObj={loc}
                  config={config}
                  refreshDetails={() => refreshDetails()}
                  showActions={!isShipper}
                  isShipper={isShipper}
                  setOutofPreplan={setOutofPreplan}
                  setIsModified={setIsModified}
                  actionType="view"
                />
                <AssignedDriverView 
                  loc={loc} 
                  drivers={drivers} 
                  warehouse_id={orderDetails.warehouse_id}
                  currentOrder={currentOrder} 
                  currentOrg={currentOrg}
                  refreshDetails={refreshDetails}
                  isCreditLimitExceed={isCreditLimitExceed}
                  account={currentOrder.account || {}}
                  showActions={showActions}
                  isShipper={isShipper}
                  setOutofPreplan={setOutofPreplan}
                  setIsModified={setIsModified}
                />

            </Tabs.TabPane>
          );
        })}
        {
        
        // !hasNewLocation && currentOrder?.status !== "COMPLETED" && !currentOrder?.is_deleted_order && <Tabs.TabPane
        !hasNewLocation && currentOrder?.status !== "COMPLETED" && <Tabs.TabPane
          tab={
          <Icon className="custom-add-stop-icon" type="plus-circle" onClick={addStop} />}
          key="add-stop"
          disabled
        />
        }
      </Tabs>
    </SectionCard>
  );
};

export default MultiStopLocationsView;
